import React from 'react'
import {ResourceSectionProps} from 'Event/template/Townhall/Dashboard/Main/ResourceSection'
import Settings from 'Event/template/Townhall/Dashboard/Main/ResourceSection/ResourceListConfig/Settings'
import SettingsPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/SettingsPanel'
import RulesPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/RulesPanel'
import ScheduleInput from 'organization/Event/DashboardConfig/ComponentConfigPanel/ScheduleInput'
import Config from 'organization/Event/Configurable/Config'
import {REMOVE, useSaveTemplate} from 'Event/TemplateUpdateProvider'
import {useConfig} from 'organization/Event/Configurable'
import StylingPanel from 'organization/Event/DashboardConfig/ComponentConfigPanel/StylingPanel'
import Styling from 'Event/template/Townhall/Dashboard/Main/ResourceSection/ResourceListConfig/Styling'
import {useAddTranslation, useRemoveTranslations} from 'Event/LanguageProvider'

export function ResourceListConfig(props: {
  section: ResourceSectionProps
  id: string
}) {
  const {section, id: sectionId} = props

  const save = useSaveTemplate()
  const removeTranslations = useRemoveTranslations()
  const addTranslation = useAddTranslation()

  const handleSave = (data: any) => {
    const {dashboardSections, navBar} = data
    const {menuItems} = navBar
    const {
      [sectionId]: {title: menuTitle, ...others},
    } = menuItems
    const {
      [sectionId]: {description, title, ...otherUpdates},
    } = dashboardSections

    save({
      ...data,
      localization: addTranslation({
        [`navBar_menuItems_${sectionId}_title`]: menuTitle,
        [`dashboardSections_${sectionId}_title`]: title,
        [`dashboardSections_${sectionId}_description`]: description,
      }),
      navBar: {
        menuItems: {
          [sectionId]: {
            title: `{{navBar_menuItems_${sectionId}_title}}`,
            ...others,
          },
        },
      },
      dashboardSections: {
        [sectionId]: {
          title: `{{dashboardSections_${sectionId}_title}}`,
          description: `{{dashboardSections_${sectionId}_description}}`,
          ...otherUpdates,
        },
      },
    })
  }

  const {
    form: {setValue, control},
  } = useConfig()

  const remove = () =>
    save({
      localization: removeTranslations([
        `navBar_menuItems_${sectionId}_title`,
        `dashboardSections_${sectionId}_title`,
        `dashboardSections_${sectionId}_description`,
      ]),
      dashboardSections: {
        [sectionId]: REMOVE,
      },
      navBar: {
        menuItems: {[sectionId]: REMOVE},
      },
    })

  return (
    <Config title="Resources" onSave={handleSave} onRemove={remove}>
      <SettingsPanel>
        <Settings section={section} id={sectionId} />
      </SettingsPanel>
      <StylingPanel>
        <Styling section={section} sectionId={sectionId} />
      </StylingPanel>
      <RulesPanel
        rules={section.rules}
        control={control}
        name={`dashboardSections.${sectionId}.rules`}
      >
        <ScheduleInput setValue={setValue} control={control} values={section} />
      </RulesPanel>
    </Config>
  )
}
